import { Pipe, PipeTransform } from '@angular/core';
import { LocationOption } from 'src/app/common-components/entity-select/location/models/location-option.interface';

@Pipe({
    name: 'ndtStreet',
    standalone: false
})
export class StreetPipe implements PipeTransform {
   transform(location: LocationOption): string {
      return transformStreet(location);
   }
}

export function transformStreet(location: LocationOption): string {
   if (location) {
      return `${location.houseNumber ?? ''} ${location.directionalPrefix ?? ''} ${location.streetName ?? ''} ${
         location.streetNameSuffix ?? ''
      } ${location.directionalPostfix ?? ''}`.replace(/  +/g, ' ');
   } else {
      return '';
   }
}
